// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_ju-0";